// Decide el tipo de error de login SOLO por el status HTTP y la ausencia de respuesta (nunca por un
// "ha fallado" generico ni parseando el body). Credenciales: 401 (backend nuevo) + 403/404 (backend
// antiguo) — el endpoint de login solo produce esos en fallo de autenticacion. Todo lo demas (5xx,
// otros 4xx, o sin respuesta: red/timeout/backend caido) => incidencia tecnica.
export function resolveLoginError(status, noResponse) {
    if (noResponse) return 'technical'
    if (status === 401 || status === 403 || status === 404) return 'credentials'
    return 'technical'
}
